export default "__VITE_ASSET__7408a2f9__"